import React from "react";
import { UNIT_TRANSLATIONS } from "../../../utils/UNIT_TRANSLATIONS";
import { Link } from 'react-router-dom';

const ProductMainRow = ({ product, expanded, onToggleExpand }) => {
  return (
    <tr className="border-b hover:bg-gray-50 transition">
      <td className="px-3 w-10">
        <button onClick={onToggleExpand}>
          <svg
            className={`w-4 h-4 transition-transform duration-200 text-[#12233A] ${
              expanded ? 'rotate-180' : ''
            }`}
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        </button>
      </td>

      <td className="px-3 py-[8px] w-20">
          <Link
              to={`/supplier-panel/supplier-product/${product.id}`}
              title="مشاهده جزئیات کالا"
            >
            <img
              src={product.featured_image_url}
              alt={product.name}
              className="w-14 h-14 object-cover rounded-lg"
            />
          </Link>
      </td>

      <td className="px-3 py-[8px] font-medium w-52">
        {product.name}
          {!product.is_active && (
                <span className="shrink-0 rounded-full bg-red-100 px-1.5 py-0.5 text-[10px] font-medium text-red-600">
                  غیرفعال
                </span>)}
      </td>

      <td className="px-3 py-[8px] w-40 text-gray-600">
        {product.category_name}
      </td>

        <td className="px-3 py-[8px] w-32 text-gray-600">
            {product.brand || "---"}
        </td>

        <td className="px-3 py-[8px] w-24 text-gray-600">
        {UNIT_TRANSLATIONS[product.unit_of_measure]}
      </td>
    </tr>
  );
};

export default ProductMainRow;